/* nuvoerc theme — hero slider & small UI helpers */
(function () {
  function initHero(root) {
    const slides = Array.from(root.querySelectorAll('.hero-slide'));
    if (slides.length < 2) return;

    const dotsWrap = root.querySelector('[data-hero-dots]');
    const prev = root.querySelector('[data-hero-prev]');
    const next = root.querySelector('[data-hero-next]');
    let index = 0;
    let timer;

    if (dotsWrap) {
      dotsWrap.innerHTML = slides
        .map((_, i) => `<button type="button" data-i="${i}" aria-label="Slide ${i + 1}"></button>`)
        .join('');
    }

    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('button')) : [];

    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('active', n === index));
      dots.forEach((d, n) => d.classList.toggle('active', n === index));
    }

    function start() {
      clearInterval(timer);
      timer = setInterval(() => go(index + 1), 5000);
    }

    prev && prev.addEventListener('click', () => { go(index - 1); start(); });
    next && next.addEventListener('click', () => { go(index + 1); start(); });
    dots.forEach((d) => d.addEventListener('click', () => { go(+d.dataset.i); start(); }));

    go(0);
    start();
  }

  function showToast(msg) {
    const t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(showToast._timer);
    showToast._timer = setTimeout(() => t.classList.remove('show'), 2400);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-hero-slider]').forEach(initHero);

    // Optional toast after add-to-cart via form submit on product cards
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', () => {
        showToast('Added to cart · Free U.S. shipping included');
      });
    });
  });
})();
